import * as Sentry from '@sentry/vue'
import {
  breadcrumbsIntegration,
  browserTracingIntegration,
  captureConsoleIntegration, contextLinesIntegration,
  dedupeIntegration, eventFiltersIntegration, extraErrorDataIntegration,
  httpClientIntegration,
  httpContextIntegration, zodErrorsIntegration,
} from '@sentry/vue'
import type { UserModule } from '@/types'

export const reloadErrors = [
  'Failed to fetch dynamically imported module', // // vite issue with new releases and old chunks: https://stackoverflow.com/questions/69300341/typeerror-failed-to-fetch-dynamically-imported-module-on-vue-vite-vanilla-set
  'Unable to preload CSS',
  'Importing a module script failed',
  'error loading dynamically imported module',
  'NetworkError',
  'FetchError',
  'XHR Error',
  'Failed to fetch',
  'Failed to complete negotiation with the server',
  'monitor_window_timeout',
  'Firebase: Error (auth/network-request-failed).',
  'The connection was stopped during negotiation.',
  'Server error',
  'Po.isUnstyled is not a function', // related to older cached chunks after new deploy
  'Object.hasOwn is not a function', // related to older cached chunks after new deploy
  'TypeError: Object.hasOwn is not a function', // related to older cached chunks after new deploy
  'Vite preload error persists after 3 reload attempts',
  'Failed to register a ServiceWorker for scope ',

  'Connection to Indexed Database server lost. Refresh the page to try again',
  'Non-Error promise rejection captured', // https://github.com/getsentry/sentry-javascript/issues/3440#issuecomment-954602174

  'interaction_in_progress: Interaction is currently in progress.', // msal firefox issue

  // sentries related to network issues that can be ignored
  'HTTP Client Error with status code:',
  'WebSocket closed with status code: 1006 (no reason given).',
  'No Connection with that ID:',
  'Invocation canceled due to the underlying connection being closed.',

]

export const install: UserModule = (app, router) => {
  if (import.meta.env.VITE_APP_SENTRY_ENVIRONMENT) {
    Sentry.init({
      app,
      debug: false,
      dsn: import.meta.env.VITE_APP_SENTRY_DSN_URL,
      tunnel: import.meta.env.VITE_APP_SENTRY_TUNNEL,
      integrations: [
        browserTracingIntegration({ router }),
        captureConsoleIntegration({
          levels: [ 'error' ],
        }),
        contextLinesIntegration(),
        httpContextIntegration(),
        extraErrorDataIntegration(),
        httpClientIntegration(),
        breadcrumbsIntegration({
          console: true,
          dom: true,
          fetch: true,
          history: true,
          sentry: true,
          xhr: true,
        }),
        dedupeIntegration(),
        eventFiltersIntegration({
          ignoreErrors: [ ...reloadErrors ],
        }),
        zodErrorsIntegration(),
      ],
      ignoreErrors: [ ...reloadErrors ],
      tracePropagationTargets: [
        'localhost',
        'portal.swipe4work.com',
        'portal.test.swipe4work.com',
        'api.swipe4work.com',
        'api.test.swipe4work.com',
        /^\//,
      ],
      release: `${import.meta.env.VITE_GIT_SHA}`,
      /*
       * Set tracesSampleRate to 1.0 to capture 100%
       * of transactions for performance monitoring.
       * We recommend adjusting this value in production
       */
      tracesSampleRate: import.meta.env.VITE_APP_SENTRY_SAMPLE_RATE,
      environment: import.meta.env.VITE_APP_SENTRY_ENVIRONMENT,
      sendDefaultPii: true,
    })
  }
}
